function seoApiFactory(storefrontApiClient) {
  const seoApi = {
    getSeoInfo(params) {
      return storefrontApiClient.get('/seo', {
        params,
      });
    },
    getGenericSeoInfo(body) {
      return storefrontApiClient.post('/onlySeo', body);
    },
    getDeepLink(params) {
      return storefrontApiClient.get('/deepLink', {
        params,
        timeout: 1000,
      });
    },
  };

  return seoApi;
}

export default seoApiFactory;
